import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { lazy, Suspense } from "react";
import { Link } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";
import { Theme } from "../../data/style/Theme";
import { useAuth } from "../../context/AuthContext";
import useScreenSize from "../../context/ScreenContext";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import { CenteredRow, MainTitle, SpacedRow } from "../../data/style/Style";
import useDrawer from "../../context/DrawerContext";
import Achievements from "../Achievements";
import noImage from "../../data/images/no-image.png";

const SettingsDrawer = lazy(() => import("./SettingsDrawer"));
const Notifications = lazy(() => import("../Display/Notifications"));
const ConversionModal = lazy(() => import("../Modals/ConversionModal"));

const LEVEL_COLORS = {
  Rookie: Theme.palette.up,
  Scaled: Theme.palette.blue,
  Intermediate: Theme.palette.gold,
  Rx: Theme.palette.orange,
};

const HeaderIcon = ({ icon, value, unit, tool }) => {
  const { size, mobileDevice } = useScreenSize();
  var [width] = size;

  return (
    <CenteredRow
      sx={{
        padding: "8px 10px",
        borderRadius: 99,
        background: Theme.palette.card,
        border: `1px solid ${Theme.palette.border}`,
        fontFamily: "Oswald, sans-serif",
        fontWeight: 700,
        // fontSize: 13,
        color: Theme.palette.orange,
      }}
      gap={width < 950 ? 0.5 : 1}
    >
      <Tooltip arrow title={tool}>
        <span style={{ fontSize: mobileDevice ? "0.7rem" : "0.9rem" }}>
          {icon}
        </span>
      </Tooltip>
      <span
        style={{
          fontSize: mobileDevice ? "0.7rem" : "0.9rem",
          color: Theme.palette.orange,
          fontFamily: "DM Sans, sans-serif",
        }}
      >
        {value}{" "}
        <span
          style={{
            color: Theme.palette.muted,
          }}
        >
          {unit}
        </span>
      </span>
    </CenteredRow>
  );
};

const Header = () => {
  const { size, mobileDevice } = useScreenSize();
  const { settings, user, profile } = useAuth();
  const { toggleDrawer, setContent } = useDrawer();
  var [width] = size;
  const lvlColor = LEVEL_COLORS[profile.hasLevel];

  let distance_weight_target_kg = (
    parseFloat(profile.biometrics?.weight) -
    parseFloat(profile.biometrics?.target_weight)
  ).toFixed(1);

  let distance_weight_target_lb = (
    parseFloat(profile.biometrics?.weight_lb) -
    parseFloat(profile.biometrics?.target_weight_lb)
  ).toFixed(2);

  let target_distance =
    settings.weight === 0
      ? distance_weight_target_kg
      : distance_weight_target_lb;

  return (
    <SpacedRow
      overflow={"auto"}
      gap={2}
      width={"100%"}
      height={"12%"}
      sx={{
        minHeight: "85px",
        background: Theme.palette.surface,
        borderBottom: `1px solid ${Theme.palette.border}`,
      }}
      alignItems={"center"}
    >
      <CenteredRow
        width={width < 950 ? "100%" : "75%"}
        gap={width < 950 ? 1 : 2}
        pl={1}
      >
        <Box p={0.5}>
          <Link to={"/profile"}>
            <img
              style={{
                height: width < 950 ? 40 : 70,
                width: width < 950 ? 40 : 70,
                borderRadius: "6px",
              }}
              alt={user.user_name}
              src={profile.image || noImage}
            />
          </Link>
        </Box>
        <CenteredRow
          flexWrap={"wrap"}
          width={"85%"}
          columnGap={2}
          rowGap={0.5}
          p={0.5}
        >
          <MainTitle
            fontSize={mobileDevice ? "0.8rem" : "1rem"}
            sx={{ textTransform: "none !important" }}
          >
            {user.user_name}
          </MainTitle>
          <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
            <span
              style={{
                fontFamily: "DM Sans, sans-serif",
                fontWeight: 700,
                fontSize: mobileDevice ? "0.7rem" : "0.9rem",
                color: lvlColor,
                padding: "2px 10px",
                borderRadius: 99,
                background: `${lvlColor}14`,
                border: `1px solid ${lvlColor}30`,
              }}
            >
              {profile.hasLevel}
            </span>
          </div>
          {/* <HeaderIcon
            mobileDevice={mobileDevice}
            width={width}
            value={profile.hasLevel}
            icon={}
            tool={"Level"}
          /> */}
          {/* <HeaderIcon
            mobileDevice={mobileDevice}
            width={width}
            text={user.total_workouts}
            icon={<FlagCircleIcon />}
            tool={"Total workouts"}
          />
          <HeaderIcon
            mobileDevice={mobileDevice}
            width={width}
            text={profile.public_wods_completed}
            icon={<RunCircleIcon />}
            tool={"Public workouts on current level"}
          /> */}
          <HeaderIcon
            value={target_distance}
            unit={settings.weight === 0 ? "kg" : "lb"}
            icon={"⚖️"}
            tool={"Distance from weight target"}
          />
        </CenteredRow>
      </CenteredRow>
      {width > 950 && !mobileDevice && (
        <CenteredRow justifyContent={"end"} height={"7vh"} gap={1} pr={2}>
          <Suspense>
            <Stack
              sx={{
                width: 36,
                height: 36,
                borderRadius: 3,
                background: Theme.palette.card,
                border: `1px solid ${Theme.palette.border}`,
                alignItems: "center",
                justifyContent: "center",
                fontSize: 17,
                cursor: "pointer",
              }}
              onClick={() => {
                toggleDrawer(true);
                setContent(<Achievements />);
              }}
            >
              <EmojiEventsIcon sx={{ color: Theme.palette.gold }} />
            </Stack>
            {/* <Stack
              sx={{
                width: 36,
                height: 36,
                borderRadius: 3,
                background: Theme.palette.card,
                border: `1px solid ${Theme.palette.border}`,
                alignItems: "center",
                justifyContent: "center",
                fontSize: 17,
                cursor: "pointer",
              }}
              // onClick={handleClick}
            >
              ⚔️
            </Stack> */}
            <ConversionModal />
            <SettingsDrawer />
            <Notifications />
          </Suspense>
        </CenteredRow>
      )}
    </SpacedRow>
  );
};

export default Header;
